import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Blind_Sample_Table from "./blind_sample_table/Blind_Sample_Table";
import Blind_Sample_Filter from "./blind_sample_filter/Blind_Sample_Filter";
import { useDispatch, useSelector } from "react-redux";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";


const Blind_Sample = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.blind_sample_report.Report,
  );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Blind_Sample_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Blind_Sample_Table
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>
    </section>
  );
};

export default Blind_Sample;
